import { Component, HostListener, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import type { INavData } from './inav-data';

/**
 * Local replacement for @reflact/ngx-layout's BodyLayoutComponent: a modern PrimeNG dashboard
 * shell (collapsible sidebar + topbar with avatar menu, PrimeNG Drawer for mobile) around a
 * content area, keeping the same input surface so consuming templates only need to swap the
 * selector/import.
 */
@Component({
  selector: 'app-body-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, DrawerModule],
  templateUrl: './body-layout.component.html',
  styleUrls: ['./body-layout.component.scss']
})
export class BodyLayoutComponent {
  @Input() public navItems: INavData[] = [];
  @Input() public showSidebar = true;
  @Input() public logoUrl = '';
  /** Optionales Badge neben dem Logo (z.B. "Intern"). */
  @Input() public logoBadge = '';
  @Input() public logoutFunction?: Function;

  public mobileNavVisible = false;
  public collapsed = false;
  public scrolled = false;

  /** Pill-Hintergrund der Topbar-Actions nur beim Scrollen einblenden, nicht am Seitenanfang. */
  @HostListener('window:scroll')
  public onWindowScroll(): void {
    this.scrolled = window.scrollY > 4;
  }

}

